import type { Entity } from '@backstage/catalog-model';
import { isUserEntity } from '@backstage/catalog-model';

export const getDisplayName = (entity?: Entity, fallback?: string): string => {
  if (!entity) {
    return 'No Display Name found';
  }
  let name: string | undefined = undefined;
  if (isUserEntity(entity)) {
    name = entity.spec.profile?.displayName;
  }

  return name ?? entity.metadata.title ?? entity.metadata.name ?? fallback;
};
